import { buildApiUrl, buildAuthHeaders } from '../config/api';
import { buildFallbackBusinessStatus } from '../utils/businessHours';

async function parseResponse(response) {
    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
        const error = new Error(data.error || data.message || 'Request failed');
        error.status = response.status;
        error.data = data;
        throw error;
    }

    return data;
}

export async function fetchBusinessStatus(options = {}) {
    const { allowFallback = true } = options;

    try {
        const response = await fetch(buildApiUrl('/api/business-closures/status'));
        return await parseResponse(response);
    } catch (error) {
        if (allowFallback) {
            return buildFallbackBusinessStatus();
        }

        throw error;
    }
}

export async function fetchBusinessClosures() {
    const response = await fetch(buildApiUrl('/api/business-closures'), {
        headers: buildAuthHeaders(),
    });

    return parseResponse(response);
}

export async function createBusinessClosure(payload) {
    const response = await fetch(buildApiUrl('/api/business-closures'), {
        method: 'POST',
        headers: buildAuthHeaders({
            'Content-Type': 'application/json',
        }),
        body: JSON.stringify(payload),
    });

    return parseResponse(response);
}

export async function updateBusinessClosure(id, payload) {
    const response = await fetch(buildApiUrl(`/api/business-closures/${id}`), {
        method: 'PUT',
        headers: buildAuthHeaders({
            'Content-Type': 'application/json',
        }),
        body: JSON.stringify(payload),
    });

    return parseResponse(response);
}

export async function deleteBusinessClosure(id) {
    const response = await fetch(buildApiUrl(`/api/business-closures/${id}`), {
        method: 'DELETE',
        headers: buildAuthHeaders(),
    });

    if (!response.ok) {
        return parseResponse(response);
    }

    return true;
}
